export const teethNumbersRowHeight = '40px';
export const teethRowHeight = '58:110';
export const unitTypeHeight = 50;
export const unitTypeWidth = 240;
export const preDefinedNotesId = 'pre-defined-notes';
